import { API } from '@/api'

export const addAnnotation = (annotation) => API.post('/annotations/', annotation);
export const updateAnnotation = (id, payload) => API.put(`/annotations/${id}/`, payload);
export const deleteAnnotation = (id, params) => API.delete(`/annotations/${id}/`, { params });
